import { SteemActionType } from '@popup/steem/actions/action-type.enum';
export const ActiveAccountReducer = (state = {
    account: {},
    keys: {},
    rc: {},
}, { type, payload }) => {
    switch (type) {
        case SteemActionType.SET_ACTIVE_ACCOUNT:
            return Object.assign(Object.assign({}, state), payload);
        case SteemActionType.SET_ACTIVE_ACCOUNT_RC:
            return Object.assign(Object.assign({}, state), { rc: payload });
        case SteemActionType.FORGET_ACCOUNT:
        case SteemActionType.FORGET_ACCOUNTS:
        case SteemActionType.RESET_ACTIVE_ACCOUNT:
            return {
                account: {},
                keys: {},
                rc: {},
            };
        default:
            return state;
    }
};
